import { RewardType } from '@bonanza-social/rewards';

export const REWARD_IMAGES: Partial<
  Record<RewardType, keyof RegisteredImages['promos']>
> = {
  Cash: 'cashOrBonus',
  Bonus: 'cashOrBonus',
  Coins: 'bonanzaPromoCoins',
  InstantWheel: 'bonanzaPromoWheel',
};

export const REWARD_IMAGE_SIZE = 24;
